/**
 * Handles no user may claim.
 *
 * MUST stay in sync with the `reserved_usernames` table seeded in
 * supabase/migrations/20260730000001_user_usernames.sql. The database is the
 * enforcing authority (its trigger rejects reserved handles for any writer,
 * including service-role); this list exists so the API and UI can reject them
 * early with a friendly message instead of surfacing a DB error.
 */
export const RESERVED_USERNAMES = new Set([
    // Roles / authority
    'admin',
    'administrator',
    'root',
    'system',
    'support',
    'help',
    'moderator',
    'staff',
    'owner',
    'security',
    'safety',
    // Routes
    'api',
    'www',
    'app',
    'web',
    'mobile',
    'login',
    'logout',
    'signup',
    'invite',
    'onboarding',
    'settings',
    'profile',
    'notification',
    'notifications',
    'user',
    'users',
    'team',
    // Mention keywords we may want to claim later (@here, @all, ...)
    'everyone',
    'here',
    'all',
    'channel',
    'you',
    // NOTE: 'me' is deliberately absent — it is 2 chars, so the 3-char minimum
    // already makes it unclaimable. Reserving it would be dead weight that
    // silently drifts from the SQL seed list. A test enforces this invariant.
    // Sentinels that would be ambiguous in logs and URLs
    'none',
    'null',
    'undefined',
    // Brand
    'crane',
    'cranesafe',
    'safe',
    // Email
    'noreply',
    'no-reply',
    'postmaster',
]);
export function isReservedUsername(candidate) {
    return RESERVED_USERNAMES.has(candidate.trim().toLowerCase());
}
//# sourceMappingURL=reserved-usernames.js.map